import { gsap } from 'gsap';
import SplitText from '../../../../../global/js/vendors/gsap-splittext/splittext';

// Registering the GSAP SplitText plugin
gsap.registerPlugin(SplitText);

/**
 * Applies animations to elements in a hero section based on its type.
 *
 * @function hero4
 * @returns {void} This function does not return a value.
 */
const hero4 = () => {
  // Fetching hero type from data attribute
  const heroElement = document.querySelector('*[data-hero-type]');

  // Exit if no hero section is found
  if (!heroElement) {
    return;
  }

  // Extract hero type from dataset
  const heroType = heroElement.dataset.heroType;

  // Selecting elements dynamically based on hero type
  const sideTitle = document.querySelector(`.o-hero-${heroType}__side-title`);
  const pretitle = document.querySelector(`.o-hero-${heroType}__pretitle`);
  const title = document.querySelector(`.o-hero-${heroType} .a-title`);
  const subtitleContent = document.querySelector(
    `.o-hero-${heroType}__content-wrapper .a-text`,
  );
  const regularButtons = gsap.utils.toArray(
    `.o-hero-${heroType}__buttons-repeater .a-btn`,
  );
  // const bgHeroSet = document.querySelector(`.o-hero-${heroType} .m-background-set-hero`);
  // const heroImage = document.querySelector(`.o-hero-${heroType} .a-img`);
  /*const heroVideo = document.querySelector(
    `.o-hero-${heroType} .m-background-set-hero__video-wrapper`,
  );*/

  // Creating a GSAP timeline for animations
  const tl = gsap.timeline();

  // Animate background hero set if available
  /*if (bgHeroSet) {
    tl.from(bgHeroSet, {
      duration: 1.4,
      autoAlpha: 0,
      yPercent: 100,
      ease: 'expo.inOut',
    });
  }*/

  // Animate hero image if available
  /*if (heroImage) {
    tl.from(
      heroImage,
      {
        duration: 1.4,
        yPercent: -80,
        scale: 1.2,
        ease: 'expo.inOut',
      },
      '<',
    );
  }*/

  // Animate hero video if available
  /*if (heroVideo) {
    tl.from(
      heroVideo,
      {
        duration: 1.4,
        yPercent: -80,
        scale: 1.2,
        ease: 'expo.inOut',
      },
      '<',
    );
  }*/

  // Animate taxonomy (breadcrumbs)
  if (sideTitle) {
    tl.fromTo(
      sideTitle,
      { opacity: 0 },
      { duration: 1, opacity: 1, ease: 'power4.inOut' },
      '<',
    );
  }

  // Animate pretitle if available
  if (pretitle) {
    tl.fromTo(
      pretitle,
      { opacity: 0, yPercent: 100 },
      {
        duration: 1.2,
        opacity: 1,
        yPercent: 0,
        ease: 'power4.inOut',
      },
      '<',
    );
  }

  // Animate title using SplitText plugin
  if (title) {
    // Splitting title into words/lines
    const splitText = new SplitText(title, {
      tag: 'span',
      type: 'lines,words',
      linesClass: 'overflow-hidden',
    });

    // Ensure title is visible before animating words
    tl.fromTo(
      title,
      { autoAlpha: 0 },
      { duration: 0.2, autoAlpha: 1 },
      '<+=0.3',
    );

    // Animate each word separately for a staggered effect
    tl.from(
      splitText.words,
      {
        duration: 1.2,
        autoAlpha: 0,
        yPercent: 100,
        stagger: 0.2,
        ease: 'power4.inOut',
      },
      '<',
    );
  }

  // Animate subtitle content if available
  if (subtitleContent) {
    tl.fromTo(
      subtitleContent,
      { autoAlpha: 0, yPercent: 100 },
      {
        duration: 1.2,
        autoAlpha: 1,
        yPercent: 0,
        ease: 'power4.inOut',
      },
      '<',
    );
  }

  // Animate regular buttons if available
  if (regularButtons.length > 0) {
    tl.fromTo(
      regularButtons,
      { autoAlpha: 0 },
      {
        duration: 0.6,
        autoAlpha: 1,
        stagger: 0.1,
      },
      '<',
    );
  }
};

export default hero4;
